module.exports = __webpack_public_path__ + "img/xhs96.fc7fe89f.png";